// frontend/src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ClerkProvider, ClerkLoaded, ClerkLoading } from "@clerk/clerk-react";
import * as Sentry from "@sentry/react";

import App from "./App.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import { Notifier } from "./components/Notify.jsx";
import { initTenantSlug } from "./lib/tenant.js";

import "/src/index.css";
import { initSentry } from "./sentry.js";

// -----------------------------------------------------------------------------
// Environment validation (Fail Fast — Google/AWS style)
// -----------------------------------------------------------------------------

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!clerkPublishableKey) {
  throw new Error("[Startup] Missing VITE_CLERK_PUBLISHABLE_KEY. Check your environment variables.");
}

// -----------------------------------------------------------------------------
// Bootstrap
// -----------------------------------------------------------------------------

// Init monitoring first (before React)
initSentry();

// Init tenant context
initTenantSlug();

// Find root safely
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("[Startup] Root element (#root) not found in index.html");
}

// -----------------------------------------------------------------------------
// App Mount
// -----------------------------------------------------------------------------

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPublishableKey}>
      <ClerkLoading>
        <div>Loading authentication...</div>
      </ClerkLoading>

      <ClerkLoaded>
        <Sentry.ErrorBoundary
          fallback={
            <div className="portal-error">
              <h2>Something went wrong</h2>
              <p>Please refresh the page. If the issue persists, contact support.</p>
            </div>
          }>
          <BrowserRouter>
            <Notifier>
              <App />
            </Notifier>
          </BrowserRouter>
        </Sentry.ErrorBoundary>
      </ClerkLoaded>
    </ClerkProvider>
  </React.StrictMode>,
);
